import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContentTitlesQuery } from "../graphql/queries";
import type {
  ContentTitlesQueryType,
  ContentTitlesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentTitlesQuery = (
  options?: QueryHookOptions<
    ContentTitlesQueryType,
    ContentTitlesQueryVariablesType
  >
) => {
  return useQuery<ContentTitlesQueryType, ContentTitlesQueryVariablesType>(
    ContentTitlesQuery,
    options
  );
};
